<template>
    <div id="verified">

        <div class="card-other">
            <h4>尊敬的用户,为了贯彻工信部《电话用户真实身份信息登记规定》,请对您购买的流量卡进行实名认证。</h4>
            <div class="main">

                <van-cell-group>
                    <van-field v-model="verifiedInfo.iccid" clearable left-icon="info-o" placeholder="请输入iccid"
                        :disabled='isFirst == 2' />

                    <van-field v-model="verifiedInfo.name" clearable left-icon="user-o" placeholder="请输入真实姓名"
                        :disabled='isFirst == 2' />

                    <van-field v-model="verifiedInfo.idcard" clearable maxlength="18" left-icon="idcard"
                        placeholder="请输入身份证号" :disabled='isFirst == 2' />

                    <van-field v-model="verifiedInfo.userPhone" maxlength="11" clearable left-icon="phone-o"
                        placeholder="请输入11位手机号码" :disabled='isFirst == 2' />
                </van-cell-group>
                <div class="btnOuter">
                    <!-- :disabled="bindFlag"  -->
                    <mt-button type="primary" size="large" @click.prevent="sureVerifiedHandler"
                        v-if="isFirst == 0">确定</mt-button>
                    <mt-button type="primary" size="large" @click.prevent="payRealName"
                        v-if="isFirst == 2">支付实名费用</mt-button>
                </div>
                <!-- <p style="color:red;padding-top:20px;">真实姓名、身份证号、手机号三者请务必与您的真实信息保持一致！</p> -->
                <div style="color:red;padding-top:20px;line-height: 24px;">
                    <p>温馨提示：</p>
                    <p>1、请确保您的实名手机号，姓名，身份证信息三者保持一致，否则将无法通过验证！</P>
                    <p>2、用户第一次申请验证，无需支付费用，第二次开始每次认证需支付0.5元信息认证费。请确保填写信息正确，以免产生额外费用，谢谢！</P>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { wxRequest, verified } from '@/api/user'
import aes from "@/utils/aes";
import { Dialog, Toast } from 'vant';
export default {
    data() {
        return {
            isNewPage:localStorage.getItem('isNewPage'),
            leshuaPay: localStorage.getItem('leshuaPay'),
            verifiedInfo: {
                iccid: localStorage.getItem('iccid'),
                name: '',
                userPhone: '',
                idcard: '',
                smsCode: '',
                isFirst: 0,
                btnTxt: '发送验证码',
            },
            bindFlag: false,
            isFirst: 0
        }
    },
    methods: {
        getSmsCode() {
            const rulut = this.$getRsaCode(this.verifiedInfo.userPhone) //加密
            var data = {
                userPhone: rulut
            }
            wxRequest("bindPhone/sms/code", data, "post").then(res => {
                if (res.data.code == 200) {
                    var n = 60;
                    this.verifiedInfo.btnTxt = '重新发送' + n + 's';
                    let timer = window.setInterval(() => {
                        n--;
                        this.verifiedInfo.btnTxt = '重新发送' + n + 's';
                        if (n < 1) {
                            window.clearInterval(timer);
                            this.verifiedInfo.btnTxt = '发送验证码';
                        }
                    }, 1000)
                } else {
                    Dialog.alert({ title: "提示", message: res.data.message });
                }
            })
        },
        getVerifiedInfoHandler() {
            var data = {
                iccid: localStorage.getItem('iccid')
            }
            wxRequest('bindPhone/phone/info/iccid', data, 'post').then(res => {
                if (res.data.code == 200 && res.data.data) {
                    for (var key in this.verifiedInfo) {
                        this.verifiedInfo[key] = res.data.data[key];
                    }
                }
            })
        },
        sureVerifiedHandler() {
            wxRequest("bindPhone/phone", this.verifiedInfo, "post").then(res => {
                if (res.data.code == 200) {
                    if (this.isNewPage == 1) {
                        this.$router.replace('/userNew/home');
                    } else {
                        this.$router.replace('/user/home');
                    }
                } else if (res.data.code == 777) {
                    Dialog.alert({ message: res.data.message, }).then(() => {//跳转到支付实名费用
                        this.isFirst = 2;
                        this.userPhone = '';
                        this.idcard = '';
                        this.name = '';
                    });
                } else {
                    this.$messagebox.alert(res.data.message);
                }
            })
        },
        //支付实名
        payRealName() {
            let fd = new FormData();
            fd.append("iccid", this.verifiedInfo.iccid);
            let _this = this;
            wxRequest('order/bind/phone', fd, 'post').then(res => {
                if (this.leshuaPay == 1) {
                    window.location.href = res.data.data.jspay_url;
                } else {
                    let param = res.data.data.param;
                    WeixinJSBridge.invoke(
                        'getBrandWCPayRequest', param,
                        function (res) {
                            if (res.err_msg == "get_brand_wcpay_request:ok") {
                                window.location.href = 'http://czlj.wzyw.cc'
                            }
                        }
                    );
                }
            })
        }
    },
    created() {
        this.getVerifiedInfoHandler();

    },

    mounted() {
        this.verifiedInfo.iccid = this.$route.query.iccid ? this.$route.query.iccid : localStorage.getItem('iccid');
        wxRequest("bindPhone/state", { iccid: this.verifiedInfo.iccid }, "post").then(res => {
            if (res.data.code == 200) {
                let result = res.data.data;
                if (result.bindState == 2) {
                    this.isFirst = result.isFirst;
                } else {
                    this.disabledFlag = true;
                }
            } else {
                Dialog.alert({ title: '提示', message: res.data.message });
            }
        })
        if (this.isFirst == 2) {
            Dialog({ message: '尊敬的用户，您当前有未支付的实名失败订单，请你优化支付完订单信息，再重新登录实名认证。' });
        }
    },
    computed: {
        bindFlag() {
            if (this.verifiedInfo.userPhone.length == 11) {
                return false;
            } else {
                return true;
            }
        },
        smsFlag() {
            if (this.verifiedInfo.userPhone.length == 11 && this.verifiedInfo.btnTxt == '发送验证码') {
                return false;
            } else {
                return true;
            }
        },

    },
}
</script>
<style lang="less">
.codeBtn {
    float: right;
    margin-top: 2px;
}

#verified {
    height: 100%;

    h4 {
        color: #fff;
        font-size: 10px;
        background: #26a2ff;
        line-height: 1.5em;
        padding: 6px 3%;
    }

    .main {
        height: calc(100% - 48px);
        padding: 0 4%;

        form {
            height: 100%;
        }

        .line {
            border-bottom: 1px solid #e5e5e5;
        }

        // .many {
        //     display: flex;
        //     justify-content: space-between;
        //     label {
        //         display: block;
        //         line-height: 36px;
        //     }
        //     .uploadOuter {
        //         position: relative;
        //         display: flex;
        //         justify-content: center;
        //         align-items: center;
        //         width: 48%;
        //         height: 100px;
        //         border: 1px dashed #e5e5e5;
        //         box-sizing: border-box;
        //         input[type=file] {
        //             position: absolute;
        //             top: 0;
        //             width: 0;
        //             width: 100%;
        //             height: 100%;
        //             opacity: 0;
        //         }                
        //         img {
        //             width: 100%;
        //             height: 100%;
        //         }
        //     }
        // }
        // .title {
        //     line-height: 28px;
        //     margin-top: 10px;
        // }
        .btnOuter {
            // display: flex;
            // align-items: center;
            // height: calc(100% - 424px;)

            margin-top: 30px;
        }
    }


    .card-dianxin {
        width: 100%;
        height: 100%;

        h1 {
            font-size: 14px;
            background: #fff;
            line-height: 1.5em;
            padding: 6px 3%;
        }

        .dianxin-iframe {
            width: 100%;
            height: 100%;
        }
    }

    .card-other {
        width: 100%;
        height: 100%;
    }

    input.van-field__control {
        padding-left: 5px;
        line-height: 24px;
    }
}
</style>
